// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mXtd6","header":"styles_header__6RCIa","contents":"styles_contents__QsrEl","footer":"styles_footer__uejbd"};